import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { UiButton, UiIcon } from 'ui-components';
import { useDispatch } from 'react-redux';
import {
  startTour,
  updateShepherdSettings,
  changeProfileMenuStep,
} from 'store';

import { usePermission } from 'hooks';
import { QuickGuide } from 'components';
import { getEnv } from 'utils';
import { Link } from 'react-router-dom';

const MobileSizeSupport = ({ close }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { userPermission } = usePermission();

  const { permission: permi_support_add } = useMemo(
    () => userPermission('Ticket', 'store'),
    [userPermission]
  );

  const handleStartTour = async () => {
    setLoading(true);
    try {
      await dispatch(startTour());
      await dispatch(updateShepherdSettings());
      close();
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  return (
    <>
      <div className='modal-header step-header'>
        <div className='header-info'>
          <UiIcon
            className='mr-0'
            icon='ri-arrow-right-s-line'
            size={20}
            color='#454545'
            onClick={() => dispatch(changeProfileMenuStep('step_1'))}
          />
          <span className='label'>{t('support:pageTitle')}</span>
        </div>
        <UiIcon
          className='header-close'
          icon='ri-close-circle-fill'
          size={20}
          color='#9CAEBB'
          onClick={close}
        />
      </div>

      <div className='modal-body'>
        <QuickGuide className='is-mobile' />

        <div className='body-ability'>
          <span>{t('support:learnAllFeaturesOfSystem')}</span>
          <div className='button--wrapper'>
            <Link
              onClick={close}
              className='blog-link'
              to={getEnv('REACT_APP_BLOG_URL')}
            >
              <UiButton variant='outlined' className='ml-5' color='primary'>
                {t('support:box.goToBlog.buttonText')}
              </UiButton>
            </Link>
            <UiButton
              variant='outlined'
              className='mr-5'
              color='primary'
              onClick={handleStartTour}
              disabled={loading}
              loading={loading}
            >
              {t('support:box.startTour.buttonText')}
            </UiButton>
          </div>
        </div>

        {permi_support_add && (
          <div className='body-support'>
            <span>{t('support:reportPageBugs')}</span>
            <div className='button--wrapper'>
              <UiButton
                variant='outlined'
                color='primary'
                onClick={() => dispatch(changeProfileMenuStep('step_5'))}
              >
                {t('support:sendFeedback')}
              </UiButton>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

MobileSizeSupport.propTypes = {
  close: PropTypes.func,
};

export default MobileSizeSupport;
